import auth from './modules/auth/state'
import router from '@/router'
import { logout } from "../api/auth";
import { getProjectTypes } from '../api/projects';
import { getAllBrandDetectionModels } from '../api/models';

export default {
  logout({ commit }) {
    logout()
      .then(() => {
        commit('logout', auth)
        router.push({name: 'login'})
      })
  },
  clearStore ({ commit }) {
    const payload = {
      auth
    }
    commit('logout', payload)
  },
  fetchProjectTypes({ commit }) {
    getProjectTypes()
      .then((res) => {
        commit('setProjectTypes', res.data.project_types)
      })
  },
  fetchAllBrandDetectionModels({ commit }) {
    getAllBrandDetectionModels()
      .then((res) => {
        commit('setBrandDetectionModels', res.data.models)
      })
  }
}
